import { fetchAuditLog } from './fetchAuditLog';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { OldAuditLogEntry } from 'src/components/atomsLegacy';
import { AuditEntry, State } from 'src/types';
import { getOldAuditLogEntryProps } from 'src/utils/getOldAuditLogEntryProps';
import styled from 'styled-components';

interface Props {
  reportID: string;
  noMargin?: boolean;
}

export const DraftAuditLog = ({ reportID, noMargin }: Props) => {
  const currentReport = useSelector(
    (state: State) => state.manualCaseCreation.mccReducer.currentReport,
  );
  const [auditLog, setAuditLog] = useState<AuditEntry[]>([]);

  // Fetch audit log on initial render and every time report is updated
  useEffect(() => {
    fetchAuditLog(reportID, setAuditLog);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAuditLog(reportID, setAuditLog);
  }, [currentReport, reportID]);

  return (
    <DraftAuditLogContainer data-testid="draft-audit-log" noMargin={noMargin}>
      {auditLog.map((audit, index) => {
        const lastAuditEntry = index === auditLog.length - 1;
        const auditLogEntryProps = getOldAuditLogEntryProps(
          audit,
          lastAuditEntry,
        );
        return (
          <OldAuditLogEntry
            key={audit.id}
            reverseColor
            {...auditLogEntryProps}
          />
        );
      })}
    </DraftAuditLogContainer>
  );
};

export const DraftAuditLogContainer = styled.div<{ noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  margin: ${(props) => (props.noMargin ? '0px' : '40px')};
  padding: 30px;
  width: 100%;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  border-radius: 9px;
  font-size: 12px;
  font-weight: 400;
  overflow-y: auto;
`;
